module.exports = __webpack_public_path__ + "static/media/toggle_closed_btn_icon.e1f6d514.svg";